// extracted by css-extract-rspack-plugin
module.exports =  {"spinner":"SubmissionStatusModal__spinner___R3JBe","paymentMethod":"SubmissionStatusModal__paymentMethod___kBOdx"};